import stringsObject from './strings.json';
import {
  ModalExpandType,
  ModalPrestigeType,
  ModalTradeType,
  ModalUnlockType,
  ModalUpgradeType,
} from './types';

type CombinedModalsType =
  | ModalExpandType
  | ModalTradeType
  | ModalUnlockType
  | ModalUpgradeType
  | ModalPrestigeType;

export const modalsHex: { [index: string]: CombinedModalsType } = {
  hex_2_0: {
    name: 'hex_2_0',
    title: stringsObject.modal.expand.title,
    description: stringsObject.modal.expand.description,
    type: 'expand',
    currency: 'blue',
    prices: [6, 20],
    minReality: 2,
  },
  hex_2_2: {
    name: 'hex_2_2',
    title: stringsObject.modal.expand.title,
    description: stringsObject.modal.expand.description,
    type: 'expand',
    currency: 'blue',
    prices: [2, 4],
    minReality: 1,
  },
  hex_2_4: {
    name: 'hex_2_4',
    title: stringsObject.modal.expand.title,
    description: stringsObject.modal.expand.description,
    type: 'expand',
    currency: 'blue',
    prices: [6, 20],
    minReality: 2,
  },
  hex_2_6: {
    name: 'hex_2_6',
    title: stringsObject.modal.expand.title,
    description: stringsObject.modal.expand.description,
    type: 'expand',
    currency: 'blue',
    prices: [2, 4],
    minReality: 0,
  },
  hex_2_8: {
    name: 'hex_2_8',
    title: stringsObject.modal.expand.title,
    description: stringsObject.modal.expand.description,
    type: 'expand',
    currency: 'blue',
    prices: [6, 20],
    minReality: 2,
  },
  hex_2_10: {
    name: 'hex_2_10',
    title: stringsObject.modal.expand.title,
    description: stringsObject.modal.expand.description,
    type: 'expand',
    currency: 'blue',
    prices: [2, 4],
    minReality: 1,
  },
  hex_2_5: {
    name: 'hex_2_5',
    title: stringsObject.modal.trade.title,
    description: stringsObject.modal.trade.description,
    type: 'trade',
    currency: 'base',
    convertTo: 'blue',
    rate: 2,
    prices: [],
    minReality: 2,
  },
  hex_4_22: {
    name: 'hex_4_22',
    title: stringsObject.modal.trade.title,
    description: stringsObject.modal.trade.description,
    type: 'trade',
    currency: 'base',
    convertTo: 'blue',
    rate: 2,
    prices: [],
    minReality: 3,
  },
  hex_2_1: {
    name: 'hex_2_1',
    title: stringsObject.modal.upgrade.title,
    description: stringsObject.modal.upgrade.description,
    lockIndex: 1,
    type: 'upgrade',
    upgrade: 'increment',
    currency: 'base',
    prices: [100],
    minReality: 2,
  },
  hex_2_9: {
    name: 'hex_2_9',
    title: stringsObject.modal.upgrade.title,
    description: stringsObject.modal.upgrade.description,
    lockIndex: 1,
    type: 'upgrade',
    upgrade: 'auto',
    currency: 'base',
    prices: [100],
    minReality: 2,
  },
  hex_4_2: {
    name: 'hex_4_2',
    title: stringsObject.modal.upgrade.title,
    description: stringsObject.modal.upgrade.description,
    lockIndex: 1,
    type: 'upgrade',
    upgrade: 'increment',
    currency: 'base',
    prices: [100],
    minReality: 3,
  },
  hex_4_10: {
    name: 'hex_4_10',
    title: stringsObject.modal.upgrade.title,
    description: stringsObject.modal.upgrade.description,
    lockIndex: 1,
    type: 'upgrade',
    upgrade: 'interval',
    currency: 'base',
    prices: [100],
    minReality: 3,
  },
  hex_4_14: {
    name: 'hex_4_14',
    title: stringsObject.modal.upgrade.title,
    description: stringsObject.modal.upgrade.description,
    lockIndex: 1,
    type: 'upgrade',
    upgrade: 'auto',
    currency: 'base',
    prices: [100],
    minReality: 3,
  },
  hex_5_0: {
    name: 'hex_5_0',
    title: stringsObject.modal.unlock.title,
    description: stringsObject.modal.unlock.description,
    type: 'unlock',
    currency: 'red',
    prices: [50],
    minReality: 0,
  },
  hex_5_5: {
    name: 'hex_5_5',
    title: stringsObject.modal.unlock.title,
    description: stringsObject.modal.unlock.description,
    type: 'unlock',
    currency: 'base',
    prices: [20],
    minReality: 0,
  },
  hex_5_10: {
    name: 'hex_5_10',
    title: stringsObject.modal.unlock.title,
    description: stringsObject.modal.unlock.description,
    type: 'unlock',
    currency: 'base',
    prices: [100],
    minReality: 0,
  },
  hex_5_15: {
    name: 'hex_5_15',
    title: stringsObject.modal.unlock.title,
    description: stringsObject.modal.unlock.description,
    type: 'unlock',
    currency: 'base',
    prices: [12],
    minReality: 0,
  },
  hex_5_20: {
    name: 'hex_5_20',
    title: stringsObject.modal.unlock.title,
    description: stringsObject.modal.unlock.description,
    type: 'unlock',
    currency: 'base',
    prices: [100],
    minReality: 0,
  },
  hex_5_25: {
    name: 'hex_5_25',
    title: stringsObject.modal.unlock.title,
    description: stringsObject.modal.unlock.description,
    type: 'unlock',
    currency: 'base',
    prices: [20],
    minReality: 0,
  },
  // Prestiges
  hex_7_0: {
    name: 'hex_7_0',
    title: stringsObject.modal.prestige.title,
    description: 'hex_7_0',
    type: 'prestige',
    actions: ['Upgrade reality', '?'],
    prices: [],
    minReality: 0,
    realityUpgrade: true,
  },
  hex_7_7: {
    name: 'hex_7_7',
    title: stringsObject.modal.prestige.title,
    description: 'hex_7_7',
    type: 'prestige',
    actions: [
      'Unlock trade base -> blue',
      'Upgrade reality',
      'Keep earned currencies',
      'Will reset all hexes',
    ],
    prices: [],
    minReality: 0,
    realityUpgrade: true,
  },
  hex_7_14: {
    name: 'hex_7_14',
    title: stringsObject.modal.prestige.title,
    description: 'hex_7_14',
    type: 'prestige',
    actions: [
      'Unlock trade base -> red',
      'No reality upgrade',
      'Keep earned currencies',
      'Will reset all hexes',
    ],
    prices: [],
    minReality: 0,
    realityUpgrade: false,
  },
  hex_7_21: {
    name: 'hex_7_21',
    title: stringsObject.modal.prestige.title,
    description: 'hex_7_21',
    type: 'prestige',
    actions: [
      'Unlock interval upgrade',
      'Unlock auto upgrade',
      'Upgrade reality',
      'Keep earned currencies',
      'Will reset all hexes',
    ],
    prices: [],
    minReality: 0,
    realityUpgrade: true,
  },
  hex_7_28: {
    name: 'hex_7_28',
    title: stringsObject.modal.prestige.title,
    description: 'hex_7_28',
    type: 'prestige',
    actions: [
      'More lovels ?',
      'No reality upgrade',
      'Keep earned currencies',
      'Will reset all hexes',
    ],
    prices: [],
    minReality: 0,
    realityUpgrade: false,
  },
  hex_7_35: {
    name: 'hex_7_35',
    title: stringsObject.modal.prestige.title,
    description: 'hex_7_35',
    type: 'prestige',
    actions: [
      'Unlock hex/flip upgrade',
      'No reality upgrade',
      'Keep earned currencies',
      'Will reset all hexes',
    ],
    prices: [],
    minReality: 0,
    realityUpgrade: false,
  },
};
